// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中
export default [
    {
        path: '/static/navigation-column',
        component: () => import('views/modules/cms/navigation/column/index.vue'),
        meta: {
            title: '导航维护',
        },
    },
    {
        path: '/static/navigation-add',
        component: () => import('views/modules/cms/navigation/add/index.vue'),
        meta: {
            title: '添加栏目',
        },
    },
    {
        path: '/static/seo-tool-robots',
        component: () => import('views/modules/cms/seo-tool/robots/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'robots',
        },
    },
    {
        path: '/static/seo-tool-dead-links',
        component: () => import('views/modules/cms/seo-tool/dead-links/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '死链',
        },
    },
    {
        path: '/static/seo-tool-website-map',
        component: () => import('views/modules/cms/seo-tool/website-map/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '网站地图',
        },
    },
    {
        path: '/static/seo-tool-seo-label',
        component: () => import('views/modules/cms/seo-tool/seo-label/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'SEO标签',
        },
    },
    {
        path: '/static/seo-tool-search-engines',
        component: () => import('views/modules/cms/seo-tool/search-engines/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '搜索引擎设置',
        },
    },
    {
        path: '/static/seo-tool-redirect',
        component: () => import('views/modules/cms/seo-tool/redirect/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '网址重定向',
        },
    },
    {
        path: '/static/seo-tool-friendly-link',
        component: () => import('views/modules/cms/seo-tool/friendly-link/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '友情链接',
        },
    },
    {
        path: '/static/seo-tool-friendly-link-type',
        component: () => import('views/modules/cms/seo-tool/friendly-link-type/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '友情链接',
        },
    },
    {
        path: '/static/seo-tool-spider-log',
        component: () => import('views/modules/cms/seo-tool/spider-log/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '搜索引擎设置',
        },
    },
    {
        path: '/static/seo-tool-keyword-density',
        component: () => import('views/modules/cms/seo-tool/keyword-density/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '关键词密度',
        },
    },
    {
        path: '/static/seo-tool-pagespider',
        component: () => import('views/modules/cms/seo-tool/pagespider/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '页面抓取标记设置',
        },
    },
    {
        path: '/static/seo-tool-keyword-density',
        component: () => import('views/modules/cms/seo-tool/keyword-density/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '关键词密度',
        },
    },
    {
        path: '/static/seo-tool-typical-page',
        component: () => import('views/modules/cms/seo-tool/typical-page/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '典型页面设置',
        },
    },
    {
        path: '/static/seo-tool-repetition-degree',
        component: () => import('views/modules/cms/seo-tool/repetition-degree/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '重复度',
        },
    },
    {
        path: '/static/seo-tool-url-rule',
        component: () => import('views/modules/cms/seo-tool/url-rules/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'URL规则管理',
        },
    },
    {
        path: '/static/empty-short-page',
        component: () => import('views/modules/cms/seo-tool/empty-short-page/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '空短页面',
        },
    },
    {
        path: '/static/dead-link-page',
        component: () => import('views/modules/cms/seo-tool/dead-link-foreign/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '空短页面',
        },
    },
    {
        path: '/static/smart-page',
        component: () => import('views/modules/cms/smart-page/index.vue'),
        meta: {
            title: '添加栏目',
        },
    },
    {
        path: '/static/seo-tool-rss',
        component: () => import('views/modules/cms/seo-tool/rss/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'rss',
        },
    },
    {
        path: '/static/sensitive-word-check/detail',
        name: 'cms-website-set-sensitive-word-check-detail',
        component: () => import('views/modules/cms/website-set/sensitive-word-check/detail.vue'),
        meta: {
            parent: '/cms/website-set/sensitive-word-check',
            icon: 'el-icon-document',
            title: '敏感词',
        },
    },
    {
        path: '/static/analysis/release-analysis/record',
        name: 'release-analysis-record',
        meta: { title: '内容发布统计', parent: '/analysis/release-analysis' },
        component: () => import('@/views/modules/analysis/release-analysis/recordList')
    },
    {
        path: '/static/image/download-record',
        name: 'DownloadRecord',
        component: () => import('views/modules/cms/img-lib/download-record.vue'),
        meta: {
            title: '下载记录',
            parent: '/cms/img-lib',
        },
    },    
];
